"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const analytics_core_1 = require("@missionlabs/analytics-core");
const analytics_utils_1 = require("@missionlabs/analytics-utils");
const InteractiveEvent = ({ subscribeTo, children, eventName, eventData, }) => (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.Children.map(children, (child) => {
    const childHandler = child.props[subscribeTo];
    if (childHandler) {
        return react_1.default.cloneElement(child, {
            [subscribeTo]: () => {
                childHandler();
                if (!(0, analytics_utils_1.isNilOrEmpty)(eventData)) {
                    (0, analytics_core_1.sendEvent)(eventName, eventData);
                }
            },
        });
    }
    return child;
})));
exports.default = InteractiveEvent;
